export default "__VITE_ASSET__BkE0tjgL__"